import { WorkerApiClient } from './services/WorkerApiClient.js';
import { ResultRenderer } from './components/ResultRenderer.js';

class AppController {
  constructor() {
    let baseUrl = 'http://127.0.0.1:8787';
    if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      baseUrl = 'https://cab2026.ixtapan.org';
    }

    this.apiClient = new WorkerApiClient(baseUrl);

    // DOM Elements
    this.searchForm = document.getElementById('searchForm');
    this.curpInput = document.getElementById('curpInput');
    this.clearBtn = document.getElementById('clearBtn');
    this.searchSubmitBtn = document.getElementById('searchSubmitBtn');
    this.searchSpinner = document.getElementById('searchSpinner');

    this.resultsContainer = document.getElementById('resultsContainer');
    this.resultRenderer = new ResultRenderer(this.resultsContainer);
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Input uppercase auto formatting & clear button visibility
    this.curpInput.addEventListener('input', (e) => {
      e.target.value = e.target.value.toUpperCase();
      this.clearBtn.style.opacity = e.target.value ? '1' : '0.5';
    });

    // Clear input button
    this.clearBtn.addEventListener('click', () => {
      this.curpInput.value = '';
      this.curpInput.focus();
      this.resultRenderer.renderEmpty();
    });

    // Submit form search
    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const query = this.curpInput.value.trim();
      if (query) {
        this.performSearch(query);
      }
    });
  }

  async performSearch(curp) {
    this.setLoading(true);

    const result = await this.apiClient.searchByCurp(curp);

    this.setLoading(false);

    if (result.status === 200 && result.data) {
      this.resultRenderer.renderSuccess(result.data);
    } else if (result.status === 404) {
      this.resultRenderer.renderNotFound(curp, result.message);
    } else {
      this.resultRenderer.renderError(result.error || 'Ocurrió un error inesperado al conectar con el servicio.');
    }
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.searchSpinner.classList.remove('hidden');
      this.searchSubmitBtn.disabled = true;
    } else {
      this.searchSpinner.classList.add('hidden');
      this.searchSubmitBtn.disabled = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const app = new AppController();
  app.init();
});
